/**
 * PUT utility-api/updateHeatingCostSplit/{utilityBillingId}, never more than one at a time per
 * utility billing (#2521).
 *
 * The backend's split checks whether the "CO2-Steuer Erstattung Vermieteranteil" heating cost
 * exists and creates it if not. Two splits running at the same time on a UB that doesn't have it
 * yet both create it, and the user sees the row twice in HeatingCostModal (reproduced on dev with
 * two splits sent 100-200 ms apart). The frontend used to send overlapping splits, e.g. when the
 * heating switch was clicked several times quickly, or when "Weiter" mounted
 * UtilityCostAllocation while HeatingCostAllocation's split was still running.
 *
 * A call made while a split is running doesn't send another one. It waits, and one more split is
 * sent after the running one has answered (so a change saved in the meantime is still included),
 * shared by everyone who asked in between. Sequential splits are harmless: the second finds the
 * row and leaves it. Every caller's onDone gets the response of a split started after its call,
 * in the shape HttpRequestAxios callbacks get (without `other`).
 */
import Autoload from '../neoverv/Autoload';

const queues = {};

const send = (utilityBillingId) => {
  const queue = queues[utilityBillingId];
  const waiting = queue.waiting;
  queue.waiting = [];
  Autoload.HttpRequestAxios.HttpRequest(
    Autoload.Setting.ub_api_base_url + 'updateHeatingCostSplit/' + utilityBillingId,
    'PUT',
    null,
    null,
    false,
    true,
    false,
    {
      done: (response) => {
        // one caller's failing callback must not leave the queue stuck for this UB
        waiting.forEach((onDone) => {
          try {
            onDone(response);
          } catch (error) {
            console.error('updateHeatingCostSplit callback failed: ', error);
          }
        });
        if (queue.waiting.length > 0) {
          send(utilityBillingId);
        } else {
          delete queues[utilityBillingId];
        }
      },
    },
    'done',
    null,
    false,
    '',
    {
      Authorization: Autoload.Utils.getAuthToken(),
    }
  );
};

export const requestHeatingCostSplit = (utilityBillingId, onDone = () => {}) => {
  if (queues[utilityBillingId]) {
    queues[utilityBillingId].waiting.push(onDone);
    return;
  }
  queues[utilityBillingId] = { waiting: [onDone] };
  send(utilityBillingId);
};
